<template>
    <div class="column">
        <div class="colorblock" v-bind:style="'background: ' + hex + ';'">
            <p>{{ name }}</p>
        </div>
        <div class="columns is-gapless is-mobile">
            <div class="column"><div class="sm-colorblock" v-bind:style="'background: rgba(' + rgb + ', 0.9);'">90%</div></div>
            <div class="column"><div class="sm-colorblock" v-bind:style="'background: rgba(' + rgb + ', 0.8);'">80%</div></div>
            <div class="column"><div class="sm-colorblock" v-bind:style="'background: rgba(' + rgb + ', 0.7);'">70%</div></div>
            <div class="column"><div class="sm-colorblock" v-bind:style="'background: rgba(' + rgb + ', 0.6);'">60%</div></div>
            <div class="column"><div class="sm-colorblock" v-bind:style="'background: rgba(' + rgb + ', 0.5);'">50%</div></div>
            <div class="column"><div class="sm-colorblock" v-bind:style="'background: rgba(' + rgb + ', 0.4);'">40%</div></div>
            <div class="column"><div class="sm-colorblock" v-bind:style="'background: rgba(' + rgb + ', 0.3);'">30%</div></div>
            <div class="column"><div class="sm-colorblock" v-bind:style="'background: rgba(' + rgb + ', 0.2);'">20%</div></div>
            <div class="column"><div class="sm-colorblock" v-bind:style="'background: rgba(' + rgb + ', 0.1);'">10%</div></div>
        </div>
        <div class="columns" id="color-details">
            <div class="column">
                <p v-if="hex"><strong>Hex:</strong> {{ hex }}</p>
                <p v-if="rgb"><strong>RGB:</strong> {{ rgb }}</p>
                <p v-if="cmyk"><strong>CMYK:</strong> {{ cmyk }}</p>
            </div>
            <div v-if="pantone || ral" class="column">
                <p v-if="ral"><strong>RAL:</strong> {{ ral }}</p>
                <p v-if="pantone"><strong>Pantone:</strong> {{ pantone }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    hex: String,
    cmyk: String,
    rgb: String,
    ral: String,
    pantone: String,
    name: String
  }
}
</script>

<style lang="scss">
.colorblock {
    // height: 50px;
    text-align: center;
    // border-radius: 8px;
    margin-bottom: 8px;
    p {
        font-weight: bold;
        color: #fff;
        mix-blend-mode: hard-light;
        padding: 50px;
    }
}
.sm-colorblock {
    // height: 30px;
    font-size: 6px;
    text-align: center;
    padding: 12px 0;
}

#color-details {
    p {
        padding-bottom: 0;
    }
}
</style>
